import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { AppContext } from "../shared/context/AppContext";

function PageNotFound() {
  const { language } = useContext(AppContext);
  const nl = language === "NL";
  return (
    <main className="PageNotFound page">
      <Helmet>
        <title>
          {nl ? "Pagina niet gevonden" : "Page not found"} | Escape Mystery
        </title>
      </Helmet>
      <div className="page-intro not-found">
        <p className="not-found-code" aria-hidden="true">
          404
        </p>
        <h1>{nl ? "Deze kamer bestaat niet" : "This room doesn't exist"}</h1>
        <p>
          {nl
            ? "Je bent lekker aan het speuren, maar deze pagina hebben we niet kunnen vinden."
            : "Nice detective work, but we couldn't find this page."}
        </p>
        <Link to="/escaperooms" className="blue-button auto-size not-found-button">
          {nl ? "Naar alle escape rooms" : "To all escape rooms"}
        </Link>
      </div>
    </main>
  );
}

export default PageNotFound;
